const env = process.env.NODE_ENV || 'development';

const config = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL,
    debug: true,
    timeout: 30000,
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL,
    debug: false,
    timeout: 30000,
  },
  test: {
    apiUrl: 'http://localhost:3000',
    debug: true,
    timeout: 5000,
  },
};

export default config[env]; 